module.exports = __webpack_public_path__ + "static/ann_wicker-d1b22377de4e9aba5a612441a9ab4536.jpg";